import { Newsletter } from "../components"
import GalleryHero from "./components/GalleryHero"
import GalleryImages from "./components/GalleryImages"

export default function Gallery() {
  return (
    <>
      <section>
        <GalleryHero />
        <GalleryImages />
        <Newsletter />
      </section>
    </>
  )
}
